import { render } from "./WeightTab.vue?vue&type=template&id=27cab2a3&ts=true"
import script from "./WeightTab.vue?vue&type=script&lang=ts"
export * from "./WeightTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__